import React from 'react'

import s from './styles.module.scss'

const KpiList = ({ items }) => {
  return (
    <div>
      {items?.map((item, index) => (
        <ul key={index}>
          <li className={s.listItem}>
            <span className={s.listLabel}>{item.label}</span> {item.value}
          </li>
        </ul>
      ))}
    </div>
  )
}

export default KpiList
